module.exports = __webpack_public_path__ + "img/sort13.00b343dd.jpg";